import { gql } from '@apollo/client';

export const ALL_GENDERS = gql`
  query getGenders {
    genders: getGenders {
      id
      name
    }
  }
`;
